import PropTypes from "prop-types";
import { initializeApollo } from "lib/apolloClient";
import PageLayout from "components/shared/pageLayout/PageLayout";
import Helpdesk from "components/helpdesk/Helpdesk";
import pollyCredentials from "../../helpers/api/polly/authentication";
import { GET_CATEGORIES_TOP_3 } from "../../helpers/api/polly/queries";

export default function HelpdeskHome({ categoriesFaq }) {
    return (
        <PageLayout slug="helpdesk">
            <Helpdesk categoriesFaq={categoriesFaq} />
        </PageLayout>
    );
}

HelpdeskHome.propTypes = {
    categoriesFaq: PropTypes.arrayOf(PropTypes.object).isRequired
};

export async function getStaticProps() {
    const apolloClient = initializeApollo();
    const data = await apolloClient.query({
        query: GET_CATEGORIES_TOP_3,
        variables: pollyCredentials,
        context: { name: "polly" }
    });
    return {
        props: { categoriesFaq: data?.data?.publication?.collections },
        revalidate: 86400
    };
}
